import { useMemo } from 'react';
import { useLocation, Link } from 'react-router-dom';

const formatMsisdn = (msisdn) => {
  if (!msisdn) return '';
  return msisdn.toString().replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4');
};

const OrderResult = () => {
  const { search } = useLocation();
  const params = useMemo(() => new URLSearchParams(search), [search]);

  const id = params.get('ID') || params.get('id');
  const status = params.get('STATUS') || params.get('status');
  const name = params.get('NAME') || params.get('name');
  const number = params.get('NUMBER') || params.get('number');
  const msisdn = params.get('MSISDN') || params.get('msisdn');

  const isFullyPaid = (status || '').toLowerCase() === 'fullypaid';
  const isOrderSent = (status || '').toLowerCase() === 'ordersent';
  const isAltSuccess = !id && !status && !!name && !!number;
  const isSuccess = isFullyPaid || isOrderSent || isAltSuccess;

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 col-md-8">
          <div className={`card shadow-sm ${isSuccess ? 'border-success' : 'border-warning'}`}>
            <div className={`card-body`}> 
              <h4 className={`card-title mb-3 ${isSuccess ? 'text-success' : 'text-warning'}`}>
                {isFullyPaid ? 'Ödəniş uğurla tamamlandı' : 
                 isOrderSent ? 'Sifarişiniz göndərildi' :
                 isAltSuccess ? 'Sorğunuz qəbul edildi' : 'Ödəniş tamamlanmadı'}
              </h4>
              {id && (
                <p className="mb-2">Sifariş ID: <strong>{id}</strong></p>
              )}
              {msisdn && (
                <p className="mb-2">Sifariş edilən nömrə: <strong>{formatMsisdn(msisdn)}</strong></p>
              )}
              {name && (
                <p className="mb-2">Ad: <strong>{name}</strong></p>
              )}
              {number && (
                <p className="mb-3">Əlaqə Nömrəsi: <strong>{number}</strong></p>
              )}
              {isFullyPaid ? (
                <p className="mb-3">Təşəkkür edirik! Ödənişiniz təsdiqləndi. Sizinlə qısa müddət ərzində əlaqə saxlanılacaq.</p>
              ) : isOrderSent ? (
                <p className="mb-3">Sifarişiniz uğurla göndərildi. Satıcı tezliklə sizinlə əlaqə saxlayacaq.</p>
              ) : isAltSuccess ? (
                <p className="mb-3">Sorğunuz uğurla göndərildi. Satıcı sizin sorğunuzu təsdiqləməlidir.</p>
              ) : (
                <p className="mb-3">Əgər problem yaşanıbsa, zəhmət olmasa yenidən cəhd edin və ya bizimlə əlaqə saxlayın.</p>
              )}

              <div className="d-flex gap-2">
                <Link to="/" className="btn btn-primary">Ana səhifəyə qayıt</Link>
                <Link to="/contact" className="btn btn-outline-secondary">Bizimlə əlaqə</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderResult;
